(function(){
	function Plugin (config) {
		if (typeof config === 'undefined')
			config = {};

		if (typeof config.where === 'undefined')
			config.where = $('body');

		if (typeof config.containerHTML === 'undefined')
			config.containerHTML = '<div id="image-viewer" class="image-viewer-hide"><div class="image-viewer-holder"><div><div class="image-viewer-controls"><span class="image-viewer-close"></span></div><div class="image-viewer-inner"></div></div></div><div class="image-viewer-backdrop"></div></div><div id="image-viewer-tmp" style="display: none;"></div>';

		this.$where = config.where;
		this.containerHTML = config.containerHTML;
		this.$body = $('body');
		this.images = {};
	}

	Plugin.prototype.setPreloader = function () {
		this.$container.append('<div class="image-viewer-preloader"><span></span><span></span><span></span></div>');
		this.$preloader = $('.image-viewer-preloader');
	}

	Plugin.prototype.setContainer = function () {
		this.$where.append(this.containerHTML);
		this.$container = $('#image-viewer');
		var _this = this;

		var eventElements = [
			{'event': 'click.image-viewer', 'el': this.$container.find('.image-viewer-close')},
			{'event': 'click.image-viewer', 'el': this.$container.find('.image-viewer-backdrop')},
			{'event': 'keyup.image-viewer', 'el': $(window)}
		];

		$.each(eventElements, function(k, item){
			item['el'].on(item['event'], function(event){
				if (item['event'] === 'keyup.image-viewer' && event.keyCode !== 27) {
					return false;
				}

				event.stopPropagation();
				event.preventDefault();

				if (window.location.hash) {
					window.location.hash = '!';
				}

				_this.$body.removeClass('image-viewer-active');
				_this.$container.addClass('image-viewer-hide');
				_this.$container.find('.image-viewer-inner').css('background-image', 'none');
			});
		});
	}

	Plugin.prototype.getImages = function () {
		this.$triggers = $('[data-iv-trigger]');
		this.$tmpContainer = $('#image-viewer-tmp');
		var _this = this;

		this.$triggers.on('click.image-viewer', function(event){
			event.stopPropagation();
			event.preventDefault();

			var $el = $(event.currentTarget);
			var img = $el.attr('href');
			var hash = $el.data('iv-hash');

			if (hash) {
				window.location.hash = hash;
			}

			if (typeof _this.images[img] === 'undefined') {
				var tmpImg = new Image();
				tmpImg.src = img;
				tmpImg.onload = function() {
					_this.images[img] = {'x': this.width, 'y': this.height};
					_this.openImage(img, _this.images[img]);
				};
			} else {
				_this.openImage(img, _this.images[img]);
			}

			_this.$container.removeClass('image-viewer-hide');
			_this.$body.addClass('image-viewer-active');
		});

		if (window.location.hash) {
			var hash = window.location.hash.slice(1);
			var $el = $('[data-iv-hash="' + hash + '"]');

			if ($el.length > 0) {
				$el.click();

				$('html, body').animate({
					scrollTop: $el.offset().top
				}, 500);
			}
		}
	}

	Plugin.prototype.openImage = function (img, size) {
		this.$container.find('.image-viewer-inner').children('img').remove();
		this.$container.find('.image-viewer-inner').append('<img src="' + img +'">');
		this.$container.find('.image-viewer-inner img').css({
			'width': '90%',
			'max-width': size.x + 'px'
		});
		this.$container.find('.image-viewer-controls').css({
			'width': '90%',
			'max-width': size.x + 'px'
		});
	}

	Plugin.prototype.init = function () {
		this.setContainer();
		this.setPreloader();
		this.getImages();
	}

	$(document).ready(function() {
		var ImageViewer = new Plugin();
		ImageViewer.init();

		// Close lightbox on overlay click
		$('.image-viewer-inner')[0].click(function (event) {
			if(event.target !== this) {
				return;
			} else {
				$('.image-viewer-close').trigger('click.image-viewer');
			}
		});
	});
})();
